"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactAccessibleAccordion = require("react-accessible-accordion");
var _accordionModule = _interopRequireDefault(require("./accordion.module.scss"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _caretRight = require("../../assets/icons/caret-right.svg");
var _caretDown = require("../../assets/icons/caret-down.svg");
var Accordion = function Accordion(_ref) {
  var items = _ref.items,
    expandedItemKey = _ref.expandedItemKey,
    onExpandedItemChange = _ref.onExpandedItemChange;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentExpandedItemKey = _useState2[0],
    setCurrentExpandedItemKey = _useState2[1];
  (0, _react.useEffect)(function () {
    setCurrentExpandedItemKey(expandedItemKey);
  }, [expandedItemKey]);
  var onItemClick = function onItemClick(key) {
    var newCurrentExpandedItemKey = key === currentExpandedItemKey ? undefined : key;
    setCurrentExpandedItemKey(newCurrentExpandedItemKey);
    if (onExpandedItemChange) {
      onExpandedItemChange(newCurrentExpandedItemKey);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.Accordion, {
    allowZeroExpanded: true,
    className: _accordionModule.default['accordion']
  }, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItem, {
      key: item.key,
      dangerouslySetExpanded: item.key === currentExpandedItemKey
    }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemState, null, function (_ref2) {
      var _classnames;
      var expanded = _ref2.expanded;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": "accordion-item",
        className: (0, _classnames2.default)(_accordionModule.default['accordion__item'], (_classnames = {}, (0, _defineProperty2.default)(_classnames, _accordionModule.default['accordion__item--expanded'], expanded), (0, _defineProperty2.default)(_classnames, _accordionModule.default['accordion__item--error'], item.isError), _classnames))
      }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemHeading, {
        className: _accordionModule.default['accordion__heading'],
        onClick: function onClick() {
          return onItemClick(item.key);
        }
      }, /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemButton, {
        className: _accordionModule.default['accordion__button'],
        "data-testid": "accordion-button"
      }, expanded ? /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
        "data-testid": "caret-down-icon",
        className: (0, _classnames2.default)(_accordionModule.default['accordion__carret-icon'], _accordionModule.default['accordion__carret-icon--down'])
      }) : /*#__PURE__*/_react.default.createElement(_caretRight.ReactComponent, {
        "data-testid": "caret-right-icon",
        className: _accordionModule.default['accordion__carret-icon']
      }), item.heading({
        expanded: expanded
      }))), /*#__PURE__*/_react.default.createElement(_reactAccessibleAccordion.AccordionItemPanel, {
        className: _accordionModule.default['accordion__panel'],
        "data-testid": "accordion-item-panel"
      }, item.content({
        expanded: expanded
      })));
    }));
  }));
};
exports.Accordion = Accordion;